<template>
  <table-stats-row-skeleton v-if="status === 'loading'" />

  <div v-else class="szw-row szw-w-full szw-text-xs szw-border-bottom">
    <span class="szw-tbl-cell__accent">{{ home }}</span>
    <span class="szw-mx-auto">{{ title }}</span>
    <span class="szw-tbl-cell__accent">{{ away }}</span>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import TableStatsRowSkeleton from './TableStatsRowSkeleton.vue'

defineProps({
  home: {
    type: String,
    default: '-'
  },
  title: {
    type: String,
    default: ''
  },
  away: {
    type: String,
    default: '-'
  }
})

const status = inject('status')
</script>
